import { snakeCase } from "lodash";
import { Link } from "react-router-dom";

import useLocalLicense from "../../licensing/hooks/useLocalLicense";
import { getUserDropdownItems } from "../utils";
import RlNavigationDropdownItem from "./components/RlNavigationDropdownItem";
import RlNavigationIcon from "./components/RlNavigationIcon";
import RlNavigationSubmenuItem from "./components/RlNavigationSubmenuItem";

type PartialUser = {
  isAdmin: boolean;
  name: string;
};

type Props = {
  user: PartialUser;
  linksReloadDocumentOverride: boolean;
};

const RlNavigationUserItem = ({ user, linksReloadDocumentOverride }: Props) => {
  const { isLocalLicenseValidOrOnline } = useLocalLicense();
  const userItems = getUserDropdownItems(
    user.isAdmin,
    isLocalLicenseValidOrOnline
  );
  return (
    <RlNavigationDropdownItem
      title={<RlNavigationIcon name="user" />}
      id="user"
    >
      <RlNavigationSubmenuItem
        className="dimmed fst-italic"
        noLink
        data-testid="main_nav_username"
      >
        @{user.name}
      </RlNavigationSubmenuItem>
      {userItems
        .filter(item => item.visible)
        .map(item => {
          const { value, label, linkReloadsDocument, visible, ...rest } = item;
          return (
            <RlNavigationSubmenuItem
              key={value}
              data-testid={snakeCase(`main_nav_menu_item_${label}`)}
            >
              <Link
                {...rest}
                reloadDocument={
                  linkReloadsDocument || linksReloadDocumentOverride
                }
              >
                {label}
              </Link>
            </RlNavigationSubmenuItem>
          );
        })}
    </RlNavigationDropdownItem>
  );
};

export default RlNavigationUserItem;
